import React from 'react';
import type { NoteField } from '../../types/disclosure';
interface NotesPanelProps {
  notes: NoteField[];
  showApiNames: boolean;
}
export function NotesPanel({
  notes,
  showApiNames
}: NotesPanelProps) {
  const [primary, ...supporting] = notes;
  return <div className="grid gap-3 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]" data-id="element-38" data-mp="3bwl7p9onmmdy">
      <article className="rounded-md border-l-4 border-blue-600 bg-blue-50/60 p-3" data-id="element-39" data-mp="37wktnq5gwd7f">
        <h3 className="text-[11px] font-semibold uppercase tracking-wide text-blue-800" data-id="element-40" data-mp="32ystk8uo5ks5">{primary.label}</h3>
        {showApiNames && <p className="font-mono text-[10px] text-blue-500" data-id="element-41" data-mp="2xxlmyd49irn2">{primary.api}</p>}
        {primary.value ? <p className="mt-1.5 whitespace-pre-line text-[13px] leading-5 text-slate-800" data-id="element-42" data-mp="2t1wjhyp4gqlh">{primary.value}</p> : <p className="mt-1.5 text-[13px] italic text-slate-400" data-id="element-43" data-mp="r8gsv1t1bbqi">No roadmap notes recorded.</p>}
      </article>

      <div className="grid gap-2 sm:grid-cols-2" data-id="element-44" data-mp="n6lpzsvggqam">
        {supporting.map(note => <article key={note.id} className="rounded-md border border-slate-200 bg-white p-2.5" data-id="element-45" data-mp="37n0bmuc3uguv">
            <h3 className="text-[11px] font-semibold uppercase tracking-wide text-slate-500" data-id="element-46" data-mp="3cmcu72vy11rn">{note.label}</h3>
            {showApiNames && <p className="font-mono text-[10px] text-slate-400" data-id="element-47" data-mp="2ynwqzlxahte9">{note.api}</p>}
            {note.value ? <p className="mt-1 whitespace-pre-line text-[13px] leading-5 text-slate-800" data-id="element-48" data-mp="32p8976du3ccf">{note.value}</p> : <p className="mt-1 text-[13px] italic text-slate-400" data-id="element-49" data-mp="3qg47mmcsp5sn">Not provided</p>}
          </article>)}
      </div>
    </div>;
}